<template>
    <div class="col input-group-sign-up">
        <small class="text-validate">
            {{ errors.first('email')}}
        </small>
        <div class="input-group">
            <input
                type="email"
                class="form-control"
                placeholder="¿Cuál es tu correo?"
                name="email"
                v-model.lazy="email"
                v-validate="'email|required'"
                @keypress.enter="newsletter">
            <div class="input-group-append">
                <button class="btn btn-outline-success" type="button"  @click="newsletter">
                    {{ newsletterText }}
                    <i class="fas" :class="icon"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SignUpForm',
    props: {
        standaloneMode: Boolean
    },
    data () {
        const email = window.localStorage.getItem("ginny::duplicated-email", this.email) || "";
        return {
            email,
            isLoading: false
        }
    },
    computed: {
        newsletterText() {
            return this.isLoading ? 'Cargando' : '¡Registrarme!';
        },

        icon() {
            return this.isLoading ? 'fa-spinner' : 'fa-paper-plane'
        }
    },
    methods:{
        async newsletter() {
            const isValid = await this.$validator.validateAll()

            if (isValid) {
                this.isLoading = true;

                let data = {
                    'email' : this.email,
                };

                axios.post(`newsletter`, data)
                .then(({data}) => {
                    this.closeModal();
                    if (Array.isArray(data) && data.length && data[0] == "Used email" ) {
                        this.showModal({duplicated: true, backToSignUp: !this.standaloneMode})
                        window.localStorage.setItem("ginny::duplicated-email", this.email)
                        return
                    }

                    this.resetForm()
                    this.showModal({success: true, backToSignUp: !this.standaloneMode})
                }).catch((e) => {
                    console.error(e)
                    // const message = error.response.data.status.message
                    this.closeModal()
                    this.resetForm();
                    this.showModal({error: true, backToSignUp: !this.standaloneMode})
                }).finally(() => {
                    this.isLoading = false;
                });
            }
        },

        resetForm() {
            this.email = "";
            window.localStorage.removeItem("ginny::duplicated-email")
            this.$validator.reset();
            this.errors.clear();
        },

        closeModal() {
            this.$modal.hide('sign-up-modal');
        },

        showModal(args) {
            this.$modal.show('sign-up-modal', args);
        }
    }
}
</script>

<style lang="scss" scoped>
.input-group-sign-up {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px;

    input {
        font-size: 14px;
        padding: 1.50rem 1.75rem;

        &::placeholder {
            color: #C2C1C0;
        }

        &:focus {
            border-color:$border-color-gray;
            box-shadow: 0 0 0 0.2rem #ededed5c;
        }
    }

    .input-group-append {
        .btn-outline-success {
            padding: 0.75rem 1.93rem;
            color: $white-color;
            border-color: $orange-color;
            background-color: $orange-color;
            box-shadow:none!important;
            font-weight:600;

            &:hover {
                background-color: $primary-color;
                border-color: $primary-color;
                box-shadow: 0 0 0 0.2rem #1f9b905c!important;
            }

            &:active {
                background-color: $primary-color!important;
                border-color: $primary-color!important;
            }
        }
    }

    .text-validate {
        color: $red-color;
        margin: 8px 0;
    }
}
// Medium devices (mobile 411px)
@media screen and (max-width:575px) {
    .input-group-sign-up {
        input {
            width: 100%;
            border-radius: 0;
        }

        .input-group-append {
            margin-left: 0px;
            width: 100%;
            border-radius: 0;

            .btn-outline-success{
                padding: 1rem 1.93rem;
                width: 100%;
                border-radius: 0;
                margin-top: 15px;
            }
        }
    }
}
</style>